<template>
  <div class="login" :style="showFilter">
    <div class="login-content">
      <div class="title">豚小伴管理系统</div>
      <div class="content">
        <div class="content-left">
          <img src="~@/assets/image/login/login-logo-n.png" alt="" />
          <!-- <div class="login-change" @click="isAdmin = !isAdmin">
            切换为{{ isAdmin ? "教师" : "管理员" }}
          </div> -->
          <div class="login-change" @click="isStudent = !isStudent">
            切换为{{ isStudent ? "教师" : "学生" }}
          </div>
        </div>
        <div class="contnet-center"></div>
        <div class="content-right">
          <!-- 管理员登录 -->
          <!-- <loginAdmin v-show="isAdmin" /> -->
          <el-tabs v-model="loginStudentActive" @tab-click="handleClick" class="tab" v-show="isStudent">
            <el-tab-pane label="学号姓名登录" name="student">
              <div class="demo-input-suffix">
                <el-form ref="student" :model="student" status-icon :rules="rules" label-width="50rpx"
                  class="demo-ruleForm">
                  <el-form-item label="" prop="studentNumber">
                    <el-input v-model="student.studentNumber" placeholder="请输入学号"
                      @keyup.enter.native="studentLogin">
                      <i slot="prefix" class="el-input__icon">
                        <img src="~@/assets/image/login/studentNumber.png" alt="" />
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="" prop="studentName">
                    <el-input v-model="student.studentName" type="studentName" placeholder="请输入姓名"
                      @keyup.enter.native="studentLogin">
                      <i slot="prefix" class="el-input__icon">
                        <img src="~@/assets/image/login/studentName.png" alt="" />
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="studentLogin" class="login-btn">立即登录</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
          </el-tabs>
          <!-- 教师登录 -->
          <el-tabs v-model="loginActive" @tab-click="handleClick" class="tab" v-show="!isStudent">
            <el-tab-pane label="短信登录" name="message">
              <div class="demo-input-suffix">
                <el-form ref="message" :model="message" status-icon :rules="rules" label-width="50rpx"
                  class="demo-ruleForm">
                  <el-form-item label="" prop="messagePhone">
                    <el-input v-model="message.messagePhone" placeholder="请输入手机号" maxlength="11">
                      <i slot="prefix" class="el-input__icon">
                        <img src="~@/assets/image/login/iphone-n.png" alt="" />
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="" prop="vcode" class="vcode">
                    <el-input v-model="message.vcode" placeholder="请输入验证码" maxlength="6"
                      @keyup.enter.native="messageLogin">
                      <i slot="prefix" class="el-input__icon">
                        <img src="~@/assets/image/login/message-n.png" alt="" />
                      </i>
                      <!-- 获取验证码 -->
                      <vcode @click.native="getVcode" ref="loginCode" slot="suffix" :localName="loginCode" class="code"
                        :duration="codeTime" @countDownOver="countDownOver" />
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="messageLogin" class="login-btn">立即登录</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="账号登录" name="account">
              <div class="demo-input-suffix">
                <el-form ref="account" :model="account" status-icon :rules="rules" label-width="50rpx"
                  class="demo-ruleForm">
                  <el-form-item label="" prop="accountPhone">
                    <el-input v-model="account.accountPhone" placeholder="请输入账号" maxlength="11"
                      @keyup.enter.native="accountLogin">
                      <i slot="prefix" class="el-input__icon">
                        <img src="~@/assets/image/login/iphone-n.png" alt="" />
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="" prop="password">
                    <el-input v-model="account.password" type="password" placeholder="请输入密码" show-password
                      @keyup.enter.native="accountLogin">
                      <i slot="prefix" class="el-input__icon">
                        <img src="~@/assets/image/login/password.png" alt="" />
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="accountLogin" class="login-btn">立即登录</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="terms">
      <a href="https://www.zlo.com.cn:8085/applet_service_agreement">使用条款</a> |
      <a href="https://www.zlo.com.cn:8085/applet_privacy_policy">隐约条款</a>
      版权所有<span style="font-size: 18px">©</span>www.bbf.com.cn  
      广州市蓝粤网络科技有限公司 
      <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2020092029号</a>
    </div>
  </div>
</template>

<script>
import JSEncrypt from "@/js_sdk/jsencrypt-Rsa/jsencrypt/jsencrypt.min.js";
import { storage } from "@/utils/storage";

// import loginAdmin from "./components/login-admin/login-admin.vue";
import vcode from "@/components/code/code"; // 验证码 公共组件

export default {
  name: "login",
  data() {
    let phoneCodeVerification = /^1[3-9][0-9]{9}$/;
    const validateAccountPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phoneCodeVerification.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    const validateStudentNumber = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入学号"));
      } else {
        callback();
      }
    };
    const validateStudentName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入姓名"));
      } else {
        callback();
      }
    };
    const validateMessagePhone = (rule, value, callback) => {
      this.isGetVcode = false;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phoneCodeVerification.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        this.isGetVcode = true;
        callback();
      }
    };
    const validateVcode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    return {
      isStudent: 0,
      showFilter: {}, //灰色滤镜
      filterData: [],
      startTime: "", //2022-12-16 12:00:00
      endTime: "", //2022-12-30 12:00:00
      isAdmin: 0, //
      loginActive: "message", // tab切换
      loginStudentActive: "student",
      // 账号信息
      account: {
        // accountPhone: "15018042206",
        // password: "LanYue123456",
        accountPhone: "",
        password: "",
      },
      message: {
        // messagePhone: "15018042206",
        // vcode: "111111",
        messagePhone: "",
        vcode: "",
      },
      student: {
        studentNumber: "",
        studentName: ""
      },
      // 验证
      rules: {
        // accountPhone: [{ validator: validateAccountPhone, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        messagePhone: [{ validator: validateMessagePhone, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        studentNumber: [{ validator: validateStudentNumber, trigger: "blur" }],
        studentName: [{ validator: validateStudentName, trigger: "blur" }],
      },
      isGetVcode: false, // 是否可以获取验证码
      codeTime: 60,

      redirect: undefined,
      otherQuery: {},

      publicKey: "", // 公钥
      encryptorPhone: "", // 加密后的手机
      encryptorPassword: "", // 加密后的密码
      loginCode: "loginCode",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  components: {
    // loginAdmin,
    vcode,
  },
  created() {
    // 判断是否需要灰色滤镜
    // this.handleFilter();
  },
  methods: {
    // 判断是否需要灰色滤镜
    handleFilter() {
      var currentTime = new Date();
      currentTime.getUTCDate();
      this.get(this.$url.globalColor)
        .then((res) => {
          // console.log(res);
          if (res.code !== 200) return;
          this.filterData = res.data;
          if (this.filterData.color == "gray") {
            this.startTime = new Date(Date.parse(this.filterData.startTime));
            this.endTime = new Date(Date.parse(this.filterData.endTime));
            if (currentTime > this.startTime && currentTime < this.endTime) {
              this.showFilter = { filter: "grayscale(100%)" };
            }
          }
        })
        .catch((err) => {
          // this.$message.error("获取滤镜失败，请联系管理员");
        });

      // this.startTime = new Date(Date.parse(this.startTime));
      // this.endTime = new Date(Date.parse(this.endTime));
      // console.log(888,currentTime>this.startTime);
      // console.log(888,currentTime<this.endTime);
      // if(currentTime>this.startTime && currentTime<this.endTime){
      //   this.showFilter = {filter: "grayscale(100%)"}
      // }
    },
    // 获取路由参数
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    // 账号登录
    accountLogin() {
      this.$refs.account.validate((valid) => {
        if (valid) {
          // console.log("账号密码登录调用接口");
          // 调用密码登录接口
          // 如果需要加密 this.getEncryp(this.account.accountPhone);
          // 如果不需要 this.selectTeacherPwdLoginPC(this.account.accountPhone)
          this.getEncryp(this.account.accountPhone);
        } else {
          return false;
        }
      });
    },
    // 验证码登录
    messageLogin() {
      this.$refs.message.validate((valid) => {
        if (valid) {
          // console.log("验证码登录调用接口");
          // 获取公钥加密，再把加密后的手机号和验证码传给后端验证
          // 获取公钥
          this.getEncryp(this.message.messagePhone);
        } else {
          return false;
        }
      });
    },
    // 学生登录
    studentLogin() {
      this.$refs.student.validate((valid) => {
        if (valid) {
          // 获取公钥加密，再把加密后的手机号和验证码传给后端验证
          // 获取公钥
          this.getEncryp(this.student.studentNumber);
        } else {
          return false;
        }
      });
    },
    // 获取验证码
    getVcode() {
      if (!this.isGetVcode) {
        return this.$message("请先填写手机号");
      }
      // 调用接口，获取验证码
      // console.log("调用接口，获取验证码");
      // 验证码倒计时
      this.$refs.loginCode.getCode();
      this.post(this.$url.selectPhoneVcodePC, {
        phone: this.message.messagePhone,
      })
        .then((res) => {
          let data = res;
          if (data.code != 200) {
            return this.$message("获取验证码失败");
          }
          return this.$message(data.msg);
        })
        .catch((err) => {
          return this.$message.error("获取验证码失败，请稍后重试");
        });
    },
    //获取公钥
    getEncryp(phone) {
      this.post(this.$url.getEncryp)
        .then((res) => {
          this.publicKey = res.msg;
          //获取到公钥，加密手机号
          this.encryptPhoneNum(phone);
        })
        .catch((err) => {
          this.$message.error("获取公钥失败，请检查网络后重试");
        });
    },
    // 公钥给手机号加密
    encryptPhoneNum(eventValue) {
      const encryptor = new JSEncrypt();
      encryptor.setPublicKey(this.publicKey); // 设置公钥
      // console.log(encryptor.encrypt(eventValue));
      this.encryptorPhone = encryptor.encrypt(eventValue); // 对手机进行加密
      if (this.isStudent) {
        return this.selectStudentLoginPC(this.encryptorPhone);
      };
      if (this.loginActive == "account") {
        // 对密码进行加密
        // md5加密
        this.encryptorPassword = this.$md5(this.account.password);
        // console.log(this.encryptorPassword)
        // 调用账号密码登录接口
        this.selectTeacherPwdLoginPC(this.encryptorPhone);
      } else {
        // 调用验证码登录接口
        this.selectTeacherLoginPC(this.encryptorPhone);
      }
    },
    // 调用学生登录接口
    selectStudentLoginPC(studentNumber) {
      this.post(this.$url.studentLoginPC, {
        studentNumber,
        studentName: this.student.studentName,
      })
        .then((res) => {
          if (res.code == 200) {
            this.setUserInfo(res, '');
          } else if (res.code == 500) {
            // this.$message.error("账号未注册或密码不正确！");
            this.$message.error(res.msg);
          } else {
            this.$message.error("登录失败");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("登录失败，请稍后重试");
        });
    },
    // 调用账号密码登录接口
    selectTeacherPwdLoginPC(phone) {
      this.post(this.$url.selectTeacherPwdLoginPC, {
        phone,
        password: this.encryptorPassword,
        terminal: 0, // 0:PC端 1:小程序 2::APP
      })
        .then((res) => {
          if (res.code == 200) {
            this.setUserInfo(res, '');
          } else if (res.code == 500) {
            // this.$message.error("账号未注册或密码不正确！");
            this.$message.error(res.msg);
          } else {
            this.$message.error("登录失败");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("登录失败，请稍后重试");
        });
    },
    // 调用验证码登录接口
    selectTeacherLoginPC(phone) {
      this.post(this.$url.selectTeacherLoginPC, {
        phone,
        vcode: this.message.vcode,
        terminal: 0, // 0:PC端 1:小程序 2::APP
      })
        .then((res) => {
          if (res.code == 200) {
            this.setUserInfo(res, this.encryptorPhone);
          } else if (res.code == 500) {
            this.$message.error(res.msg);
            // this.$message.error("验证码不正确！");
          } else {
            //提示登录失败
            this.$message.error("登录失败");
          }
        })
        .catch((err) => {
          this.$message.error("登录失败，请稍后重试");
        });
    },
    // 登录成功后
    setUserInfo(res, phone) {
      // let phoneStr =
      //   phone.substr(0, 3) + "****" + phone.substr(7, phone.length);
      // 将token存到缓存中
      // console.log(res,phone);
      storage
        .setStorageSync("bbfAdminTeacherToken", res.data.token)
        .then(() => {
          this.get(this.$url.getTeacherByToken).then((resInfo) => {
            console.log("根据token获取个人信息==>", resInfo);
            window.localStorage.setItem("menuPermissions", resInfo.data.menuPermissions);
            localStorage.setItem("hasPulledOfflineMessages", false);
            // localStorage.setItem('mindId', 0);
            // 假设resInfo.data是你的用户信息数据，而res.data.loginInfo包含了accessToken和refreshToken
            let userInfo = resInfo.data; // 用户信息

            // 从登录响应中获取accessToken和refreshToken
            let loginInfo = res.data.loginInfo;
            if (loginInfo && (loginInfo.accessToken || loginInfo.refreshToken)) {
              // 将accessToken和refreshToken添加到userInfo对象中
              userInfo.accessToken = loginInfo.accessToken;
              userInfo.refreshToken = loginInfo.refreshToken;
            }

            // 将更新后的userInfo对象转换为JSON字符串并存储到localStorage中
            window.localStorage.setItem("local_userInfo", JSON.stringify(userInfo));
            // window.localStorage.setItem("local_userInfo", JSON.stringify(resInfo.data));

            if(this.isStudent) return this.$router.push({ path: "/evaluation-management" });

            if (resInfo.data.schoolId) {
              this.$message.success("登录成功");
              // this.$router
              //   .push({
              //     // path: this.redirect || "/",
              //     path: "/",
              //     query: "welcome",
              //   })
              //   .catch(() => {});
              this.$router
                .push({
                  // path: this.redirect || "/",
                  path: "/",
                  query: "home-page",
                })
                .catch(() => { });
              return;
            } else {
              this.$router
                .push({
                  // path: this.redirect || "/",
                  path: "/",
                  query: "userinfo-add",
                })
                .catch(() => { });
            }
            // 跳转
            // this.$router
            //   .push({
            //     path: this.redirect || "/",
            //     query: this.otherQuery,
            //   })
            //   .catch(() => {});
          });
          // 用户id
          // window.localStorage.setItem("tid", res.data.id);
          // this.resetLoginHandled();
        })
        .catch((err) => {
          this.$message.error("登录失败，请稍后重试");
        });
    },
    //验证码倒计时结束
    countDownOver() {
      // console.log("倒计时结束");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./login.scss";
</style>
